import fullFunctionalityConfig from './fullFunctionalityConfig'
import responsiveConfig from './responsiveConfig'
import type {DSConfig} from '@wix/document-services-types'

const createFeedbackConfig = (base: Omit<DSConfig, 'origin'>): DSConfig => ({
    ...base,
    modulesList: base.modulesList,
    continuousSave: false,
    disableAutoSave: true,
    isReadOnly: false,
    keepMultiLingualModelsFromServer: true,
    autosaveRestore: 'false',
    cedit: false,
    origin: 'experts_feedback',
    disableSave: true
})

const responsive = createFeedbackConfig(responsiveConfig)
const classic = createFeedbackConfig(fullFunctionalityConfig)

export {responsive, classic}
